/* No trackers are installed here. The existing Shopify publisher is the sole sink. */
(function () {
  'use strict';
  if (window.DSULabsAnalytics) return;
  var element = document.getElementById('dsu-tracking-config');
  var config;
  try { config = JSON.parse(element.textContent); } catch (_) { return; }
  var seenEvents = new WeakSet();
  var milestones = new Set();
  var names = new Set(['assessment_start', 'assessment_complete', 'email_signup', 'affiliate_click']);
  function production() {
    return config.enabled === true && config.production === true &&
      !window.Shopify?.designMode && !window.Shopify?.previewMode &&
      (!window.Shopify?.theme?.role || window.Shopify.theme.role === 'main') &&
      !new URLSearchParams(window.location.search).has('preview_theme_id') &&
      !new URLSearchParams(window.location.search).has('dsu_test');
  }
  function permitted() {
    try { return production() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function send(name, properties) {
    if (!names.has(name) || !permitted()) return false;
    try {
      var publish = window.Shopify?.analytics?.publish;
      if (typeof publish !== 'function') return false;
      // No URL, query string, link text, email, answers or result category is sent.
      Promise.resolve(publish.call(window.Shopify.analytics, 'dsulabs:' + name, properties)).catch(function () {});
      return true;
    } catch (_) { return false; }
  }
  function milestone(name) {
    if (milestones.has(name)) return false;
    if (!send(name, {content_id: 'dark-spot-routine-finder'})) return false;
    milestones.add(name); return true;
  }
  window.DSULabsAnalytics = Object.freeze({
    // Future host integration must call only after the real action succeeds.
    assessmentStart: function () { return milestone('assessment_start'); },
    assessmentComplete: function () { return milestone('assessment_complete'); },
    emailSignupConfirmed: function () {
      if (milestones.has('email_signup')) return false;
      if (!send('email_signup', {content_id: 'dsulabs-newsletter'})) return false;
      milestones.add('email_signup'); return true;
    }
  });
  function onClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (event.isTrusted !== true || event.defaultPrevented || seenEvents.has(event)) return;
    var link = event.target?.closest?.('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (url.protocol !== 'https:' || !['amazon.com','www.amazon.com'].includes(url.hostname)) return;
    if (!url.searchParams.get('tag')) return;
    var match = url.pathname.match(/^\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/);
    if (!match) return;
    seenEvents.add(event);
    var position = ['review-verdict','review-body','comparison-card'].includes(link.dataset.ctaPosition) ? link.dataset.ctaPosition : 'content';
    send('affiliate_click', {retailer:'amazon', product_id:match[1], content_id:config.contentId, cta_position:position});
    // Never prevent default, await analytics, rewrite a URL or redirect a visitor.
  }
  document.addEventListener('click', onClick);
  document.addEventListener('auxclick', onClick);
  // A page without the consent API fails closed until it becomes available.
  if (production() && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function () {}); } catch (_) {}
  }
}());
